import { useMemo } from 'react';

import DEFAULT_FORM_MESSAGES from '../constants/defaultMessages';

import useLocalization from './use-localize';

/**
 * Enhanced translation hook specifically for FormBuilder components
 * Provides translation with comprehensive fallback strategy
 */
const useFormTranslations = () => {
  const formatMessage = useLocalization();

  const translateFormField = useMemo(
    () =>
      (translationKey: string | null | undefined): string => {
        // Handle null/undefined keys
        if (!translationKey) {
          return translationKey ?? '';
        }

        // Try Redux messages first, then static defaults, then return original value
        const translatedText = formatMessage(
          translationKey,
          DEFAULT_FORM_MESSAGES[translationKey] ?? translationKey
        );

        return translatedText;
      },
    [formatMessage]
  );

  const translatePlaceholder = useMemo(
    () =>
      (translationKey: string | null | undefined): string => {
        if (!translationKey) {
          return translationKey ?? '';
        }

        return formatMessage(
          translationKey,
          DEFAULT_FORM_MESSAGES[translationKey] ?? translationKey
        );
      },
    [formatMessage]
  );

  return {
    translateFormField,
    translatePlaceholder,
    formatMessage, // Expose original hook for other uses
  };
};

export default useFormTranslations;
